import { render, staticRenderFns } from "./ServerSelection.vue?vue&type=template&id=70b037db&scoped=true"
import script from "./ServerSelection.vue?vue&type=script&lang=js"
export * from "./ServerSelection.vue?vue&type=script&lang=js"
import style0 from "./ServerSelection.vue?vue&type=style&index=0&id=70b037db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b037db",
  null
  
)

export default component.exports